import type { DownloadScope } from '../types';
import { Icon } from '@/new/components/icon';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/new/components/shadcn/select';

interface Props {
  value: string;
  onChange: (value: string) => void;
  scopes: readonly DownloadScope[];
}

export const ScopeField = ({ value, onChange, scopes }: Props) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className="border-blue-100 bg-blue-50/50 text-blue-700 hover:bg-blue-100/50 [&>svg]:text-blue-400">
      <Icon className="lucide--layers mr-2 text-blue-400" />
      <SelectValue placeholder="Select scope" />
    </SelectTrigger>
    <SelectContent>
      <SelectGroup>
        {scopes.map((s) => (
          <SelectItem key={s.id} value={s.id}>
            {s.label}
          </SelectItem>
        ))}
      </SelectGroup>
    </SelectContent>
  </Select>
);
